//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';

//import Components
import DepartmentCard from './DepartmentCard/DepartmentCard';
import Fullpage from '../../../hoc/Fullpage/Fullpage';
import Language from '../../../language/language.json';

import * as homeActions from '../actions/homeActions'

//import Style classes
import './Company.css';
import HomepageManager from '../../Admin/HomepageManager/HomepageManager';
// import { stat } from 'fs';

class Company extends Component{

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        this.props.onLoadDepartment('constructions');
        this.props.onLoadDepartment('materials');
        this.props.onLoadDepartment('fertilizers');
        this.props.onLoadDepartment('mediums');
        this.props.onLoadDepartment('extras');
        this.props.onLoadDepartment('cards');
    }

    render() {
        if (!this.props.company[0].subDepartments[0].items ||
            !this.props.company[0].subDepartments[1].items ||
            !this.props.company[1].subDepartments[0].items ||
            !this.props.company[1].subDepartments[1].items ||
            !this.props.company[1].subDepartments[2].items ||
            !this.props.company[2].items) {
                return (
                    <div className='Company'>
                        <div>
                        </div>
                    </div>
                );
        }

        let departments = this.props.company.map((obj, idx) => {
                if(idx <= 1)
                    return (
                        <DepartmentCard data={obj} key={idx} index={idx} lang={this.props.universal.language} />
                    )
        })


        return (
            <div className='Company'>
                {departments}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        company : state.company
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadDepartment : (subDepartment) => {
            dispatch(homeActions.loadDepartment(subDepartment))
        }       
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Company);


// WEBPACK FOOTER //
// ./src/pages/Home/Company/Company.js